import { Navigate } from 'react-router-dom';
import {
  ApiError,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  ContractRegisterView,
  ErrorText,
} from '@dataroom/shared';
import { useBuyerRoomAccess, useContractRegister } from '@/api/hooks';

/**
 * "Contracts" in the buyer portal (ADR-0054): the contract register over ONLY the
 * documents this buyer can already open — the server builds it from the buyer's
 * own document listing. Read-only: dates as each document states them, with the
 * plain date flags (the closing flag uses the buyer's own closing date).
 */
export function ContractsPage() {
  const access = useBuyerRoomAccess();
  if (access.status === 'login') return <Navigate to="/login" replace />;
  if (access.status === 'loading') {
    return (
      <p className="mx-auto w-full max-w-container px-4 py-6 text-sm text-muted-foreground md:px-6">
        Loading…
      </p>
    );
  }
  if (access.status === 'forbidden') return <Navigate to="/" replace />;
  return <ContractsInner roomId={access.roomId} />;
}

function ContractsInner({ roomId }: { roomId: string }) {
  const register = useContractRegister(roomId);
  if (register.error instanceof ApiError && register.error.status === 401) {
    return <Navigate to="/login" replace />;
  }
  return (
    <div className="mx-auto w-full max-w-container px-4 py-6 md:px-6">
      <Card>
        <CardHeader>
          <CardTitle>Contracts</CardTitle>
          <p className="text-sm text-muted-foreground">
            Key dates of the contracts you can see in this room, earliest expiration first.
          </p>
        </CardHeader>
        <CardContent>
          {register.isLoading ? (
            <p className="text-sm text-muted-foreground">Loading…</p>
          ) : register.error ? (
            <ErrorText error={register.error} />
          ) : register.data ? (
            <ContractRegisterView
              register={register.data}
              emptyText="No contracts have been shared with you yet."
            />
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}
